import React from 'react'
import { Box } from '@mui/material'
import { useGetTreeById } from 'reducers/trees_hooks'
import { GoogleLoginButton, googleUserAtom } from 'infrastructure/googleDrive'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { ExportStandards } from './Export'
import { ImportStandards } from './Import'

export function BulkAddStandards({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const treeData = useGetTreeById({ treeId, versionId })
  const guser = useAtomValue(googleUserAtom)

  if (!treeData.tree) return <Box>Loading...</Box>

  if (!guser.credential?.accessToken) {
    return (
      <Box>
        <GoogleLoginButton hideWhenLoggedIn={true} />
      </Box>
    )
  }

  return (
    <Box>
      <Box>Bulk Add Standards</Box>

      <ExportStandards
        tree={treeData.tree}
        accessToken={guser.credential.accessToken}
      />
      <ImportStandards tree={treeData.tree} />
    </Box>
  )
}
